import { bedrockRuntimeEndpoint } from "../../connectors/awsBedrock/manifest";
import {
  ANTHROPIC_CONTEXT_LIMIT_PATTERNS,
  ANTHROPIC_MODEL_EFFORTS,
} from "../anthropic/manifest";
import { defineAIProviderManifest } from "../manifest";

const BEDROCK_ATTACHMENT_SUPPORT = {
  documentMediaTypes: [
    "application/pdf",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  ],
  maxImageDimension: 2000,
} as const;

const BEDROCK_MODEL_DEFAULTS = {
  defaultChatModel: "claude-opus-5",
  defaultFastModel: "claude-haiku-4-5-20251001",
  defaultChatEffort: "low",
  modelEfforts: ANTHROPIC_MODEL_EFFORTS,
  reasoningReplay: { via: "signature", providerOptionsKey: "bedrock" },
  contextLimitPatterns: [
    ...ANTHROPIC_CONTEXT_LIMIT_PATTERNS,
    "input is too long for requested model",
  ],
} as const;

export const manifest = defineAIProviderManifest({
  id: "bedrock-anthropic",
  label: "Amazon Bedrock (Anthropic)",
  description:
    "Route through Amazon Bedrock using your server's AWS credentials.",
  ...BEDROCK_MODEL_DEFAULTS,
  configurable: false,
  requiresChatModel: false,
  credentialFields: [],
  packCredentials: () => ({ baseUrl: "", apiKey: "" }),
  unpackCredentials: () => ({}),
  subtitleField: null,
  attachmentSupport: BEDROCK_ATTACHMENT_SUPPORT,
});

export const connectorManifest = defineAIProviderManifest({
  id: "awsBedrock",
  label: "Amazon Bedrock",
  description: "Run Claude models on your own Amazon Bedrock account.",
  connectorIdentifier: "awsBedrock",
  endpointFromConnector: true,
  connectorBaseUrl: bedrockRuntimeEndpoint,
  ...BEDROCK_MODEL_DEFAULTS,
  configurable: true,
  // Our model aliases only map to us/ca/eu/au geo inference profiles, so a
  // tenant picks from the models their own account exposes instead.
  requiresChatModel: true,
  credentialFields: [
    {
      key: "apiKey",
      label: "AWS credentials",
      description: "Supplied by the connector.",
      placeholder: "",
      sensitive: true,
      required: true,
    },
  ],
  packCredentials: () => ({ baseUrl: "", apiKey: "" }),
  unpackCredentials: (row) => ({ baseUrl: row.baseUrl }),
  subtitleField: "baseUrl",
  attachmentSupport: BEDROCK_ATTACHMENT_SUPPORT,
});
